import { Link } from 'react-router-dom'

export const A = (props: any) => {
  const to = props.to

  return <Link {...props} to={to} />
}
